import React, { Component } from 'react';
import { urlApi } from '../Constants/Global';
import { Container, Row, Col } from 'react-bootstrap';
import parse from 'html-react-parser';
import Bg from '../Images/bg/bg-gs.png';

export class SectionAbout extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalTitle: '',
      modalImage: '',
      modalMessage: '',
      modalShow: false
    };

    this.handleClose = this.handleClose.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  handleClose() {
    this.setState({ modalShow: false });
  }

  handleShow() {
    this.setState({ modalShow: true });
  }

  viewMore() {
    this.handleShow();
  }

  render() {
    return (
      <>
        <section id="about" className="p-0" style={{ backgroundImage: 'url(' + Bg + ')', backgroundRepeat: 'no-repeat', backgroundSize: '40rem', backgroundPosition: '105% 80%' }}>
          <Container fluid>
            <Row>
              <Col xs={12} md={6} className="ps-0 pe-0">
                <div className='bg-img ratio-4x3' style={{ backgroundImage: 'url(' + urlApi + '/storage/article/' + this.props.contents.item.row_value + ')' }}></div>
              </Col>
              <Col xs={12} md={6} className="px-5 fs-5">
                <h2 className='font-header mt-3'>{this.props.contents.item.name}</h2>
                {this.props.contents.item.detail ? parse(this.props.contents.item.detail) : ''}
              </Col>
            </Row>
          </Container>
        </section>
        {/* {this.props.contents.map((item, index) => (
          <>
            <section id="about" className={"section section-about ibg-tertiary " + this.props.sectionGap}>
              <Container>
                <Row key={index}>
                  <Col lg={5} md={12}>
                    <div className="p-5">
                      <h5><hr />{item.set1}</h5>
                      <h2 className='mb-4'>{item.set2}</h2>
                      <p>
                        {item.set3}
                        <br />
                        <button className="btn btn-sm ibt-primary px-3 mt-3" onClick={() => this.viewMore()}>{item.set5}</button>
                      </p>
                    </div>
                  </Col>
                  <Col lg={7} md={12}>
                    <div className="bg-img ratio-4x3 mb-2" style={{ backgroundImage: "url('" + urlApi + '/storage/media/' + item.set4 + "')" }}></div>
                  </Col>
                </Row>
              </Container>
            </section>

            <Modal show={this.state.modalShow} onHide={this.handleClose} fullscreen={true}>
              <Modal.Header closeButton>
                <Modal.Title className="itx-primary text-center w-100">{this.state.modalTitle}</Modal.Title>
              </Modal.Header>
              <Modal.Body className="itx-dark p-5" scrollable={true}>
                <Row>
                  <Col sm={{ span: 12, offset: 0 }} md={{ span: 10, offset: 1 }} xl={{ span: 8, offset: 2 }}>
                    <div className="ict-container">{item.set6 ? parse(item.set6) : ''}</div>
                  </Col>
                </Row>
                <Row>
                  <Col sm={{ span: 12, offset: 0 }} md={{ span: 10, offset: 1 }} xl={{ span: 8, offset: 2 }}>
                    <div className="ict-container">{item.set7 ? parse(item.set7) : ''}</div>
                  </Col>
                </Row>
                <Row>
                  <Col sm={{ span: 12, offset: 0 }} md={{ span: 10, offset: 1 }} xl={{ span: 8, offset: 2 }}>
                    {item.set8 ? parse(item.set8) : ''}
                  </Col>
                </Row>
                <Row>
                  <Col sm={{ span: 10, offset: 1 }} md={{ span: 8, offset: 2 }} xl={{ span: 6, offset: 3 }}>
                    {item.set9 ? parse(item.set9) : ''}
                  </Col>
                </Row>
                <Row>
                  <Col sm={{ span: 12, offset: 0 }} md={{ span: 10, offset: 1 }} xl={{ span: 8, offset: 2 }}>
                    <div class="card">
                      <div class="card-body">
                        <blockquote class="blockquote p-2 p-md-5 mb-0">
                          {item.set10 ? parse(item.set10) : ''}
                        </blockquote>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Modal.Body>
            </Modal>
          </>
        ))} */}
      </>
    )
  }
}

SectionAbout.defaultProps = {
  contents: {
    item: {
      name: '',
      detail: '',
      row_value: ''
    },
    contents: []
  }
}

export default SectionAbout